<template>
    <v-card class="flex-row" flat tile width="100%">
        <v-card-title v-if="title">
            {{ title }}
        </v-card-title>
        <v-data-table :headers="headers" :items="userList" :search="search" sort-by="weight" item-class="cellClass" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" :loading="loading">
            <template v-slot:[`item.avatar`]="{ item }">
                <v-avatar v-if="item.pictureUrl" size="32" class="mr-2">
                    <img :src="item.pictureUrl" />
                </v-avatar>
                <v-avatar v-else color="info" size="32" class="mr-2">
                    <v-icon dark> mdi-account-circle </v-icon>
                </v-avatar>
                {{ item.name }}
            </template>
        </v-data-table>
    </v-card>
</template>
    
    <script>
    import formatData from "../utils/formatData"
    // import getGroupInfoById from "../data/getGroupInfoById";
    // import bqGetReportChallengeDataByGroup from "../data/bqGetReportChallengeDataByGroup";
    export default {
        data() {
            return {
                search: "",
                options: {
                    itemsPerPage: 20,
                },
                headers: [{
                        text: "Name",
                        value: "avatar",
                        sortable: false,
                    }, 
                    {
                        text: "Employee Id",
                        value: "employeeId",
                        width: "120"
                    },
                    {
                        text: "Weight Change (kg)",
                        value: "weight_loss",
                        width: "120"
                    },
                    {
                        text: "Weight Change (%)",
                        value: "weight_loss_percent",
                        width: "120"
                    },
                    // {
                    //     text: "BMI Changes",
                    //     value: "bmi_changes",
                    //     width: "120"
                    // },
                    {
                        text: "Total Steps",
                        value: "steps",
                        width: "120"
                    }, 
                    {
                        text: "Distance (km)",
                        value: "distance",
                        width: "120"
                    }, 
                    {
                        text: "Exercise (mins)",
                        value: "workout_minutes",
                        width: "120"
                    }, 
                    {
                        text: "Exercise (count)",
                        value: "workout_number",
                        width: "120"
                    },
                    {
                        text: "Servings",
                        value: "servings",
                        width: "120"
                    },
                    {
                        text: "Points",
                        value: "healthpoints_total",
                        width: "120"
                    }
                ],
                loading: false,
                datatest: []
            };
        },
    
        created() {   
            // this.group_id = this.$attrs.group_id;
            // this.id = this.$attrs.id;
        },
        computed: {
            title(){
                return this.$attrs.title;
            },
            userList(){
                return this.$attrs.userList;
            },
            groupInfo(){
                return this.$attrs.groupInfo;
            }
        },
        methods: {
            _formatData(type, value) {
                return formatData(type, value);
            },
            goToGroupList() {
                this.$router.push(`/challenge/${this.id}`);
            }
        },
    };
    </script>
    